module.exports = __webpack_public_path__ + "static/media/contact.91194a5a.svg";